import Store from "../../../../../../Store";

import lt from "./images/lt.png";

export const mockImages = { lt };

export const getMockImage = () => {
  const short = Store.getUserPlatformLangShort();
  return mockImages[short];
};
